import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { shipmentStatuses, useFetch } from '@reveni-io/reveni-ui'

import { isTrackingParcel } from '@/parcels/helpers/helpers'
import parcelServices from '@/parcels/services/services'

import { copiesByEmailDestination, emailDestinations } from './constants'
import { parseCcEmails } from './helpers'
import { transformRequestSendParcelEmail } from './transformers'

const useSendEmail = ({
  storeId,
  relatedId,
  setToastInfo,
  refetchParcel,
  customerEmail,
  storeReplyToEmail,
  carrierEmail,
  parcel,
}) => {
  const { t } = useTranslation()
  const [showSendEmailModal, setShowSendEmailModal] = useState(false)
  const [destination, setDestination] = useState(emailDestinations.customer)
  const [to, setTo] = useState('')
  const [cc, setCc] = useState('')
  const [replyTo, setReplyTo] = useState('')
  const [subject, setSubject] = useState('')
  const [body, setBody] = useState('')
  const { fetchData, loading } = useFetch(parcelServices.sendParcelEmail, { doInitialRequest: false })

  useEffect(() => {
    if (!showSendEmailModal) {
      setDestination(emailDestinations.customer)
      setTo('')
      setCc('')
      setReplyTo(storeReplyToEmail || '')
      setSubject('')
      setBody('')
    }
  }, [showSendEmailModal, storeReplyToEmail])

  const onSendEmail = async () => {
    const payload = transformRequestSendParcelEmail({ to, ccEmails: parseCcEmails(cc), replyTo, subject, body })

    try {
      await fetchData({
        storeId,
        relatedId,
        destination,
        payload,
      })
      setShowSendEmailModal(false)
      refetchParcel()
      setToastInfo({ type: 'success', message: t('Email enviado correctamente') })
    } catch (error) {
      setToastInfo({ type: 'error', message: error.message })
    }
  }

  const openSendEmailModalForContactCustomer = () => {
    setDestination(emailDestinations.customer)
    setShowSendEmailModal(true)
    setTo(customerEmail)
  }

  const openSendEmailModalForContactCarrier = () => {
    setDestination(emailDestinations.carrier)
    setShowSendEmailModal(true)
    setTo(carrierEmail)
  }

  const closeSendEmailModal = () => {
    setShowSendEmailModal(false)
  }

  const allowSendEmail = !isTrackingParcel(parcel) && parcel?.status !== shipmentStatuses.cancelled

  return {
    showSendEmailModal,
    openSendEmailModalForContactCustomer,
    openSendEmailModalForContactCarrier,
    closeSendEmailModal,
    destination,
    setDestination,
    to,
    setTo,
    cc,
    setCc,
    replyTo,
    setReplyTo,
    subject,
    setSubject,
    body,
    setBody,
    onSendEmail,
    loading,
    copies: copiesByEmailDestination[destination],
    allowSendEmail,
  }
}

export default useSendEmail
